import {container} from './RecommendTmpl';
import {cardItem} from '../../common/CardTmpl';

export default class Recommend {
    constructor( _container, _option ){
        this.nameIs = 'class-Recommend';
        this.option = _option;

        this.container = $(_container);
        this.container.html( container(_option.list.length) );

        this.itemContainer = $(_container + ' ul.recommend-list');
        this.openBtn = $( this.option.el_sel + ' .main-movie-player .player-recommend' );
        this.openBtn.toggle(_option.list.length>3);
        this.closeBtn = $( _container + ' a.recommend-close' );

        _option.list.map( (item, idx) => {
            this.itemContainer.append( $(cardItem(item, 'recommend')) );
        } );

        this.slickItem = $(_container + ' ul.recommend-list').slick({
            dots: false, arrows: true, infinite: false,
            speed: 600, slidesToShow: 4, slidesToScroll: 2,
            responsive: [
                {
                    breakpoint: 960,
                    settings: {
                        arrows: false,
                        slidesToScroll: 1,
                        slidesToShow: 1
                    }
                }
            ]
        });

        this.slickItem.on('beforeChange', (event, slick, currentSlide, nextSlide)=>{
            this.container.find( '.paging .paging-count .is-active' ).text( nextSlide+1 );
        });

    }

    addEvents(){
        this.openBtn.on('click', (e)=>{
            this.openRecommend();
            return false;
        } );
        this.closeBtn.on( 'click', (e)=>{
            this.closeRecommend();
            return false;
        } );

        this.container.on('click', (e)=>{
            if( e.currentTarget == e.target ){
                this.closeRecommend();
                return false;
            }
        } );
    }

    openRecommend(){
        $(this.option.el_sel).trigger({type:'RECOMMEND_OPEN', who: this.nameIs});
        this.container.addClass('is-active');
        TweenMax.to(this.container, 0.5, {opacity:1});
    }

    closeRecommend(){
        $(this.option.el_sel).trigger({type:'RECOMMEND_CLOSE', who: this.nameIs});
        TweenMax.to(this.container, 0.2, {opacity:0, onComplete: ()=>this.container.removeClass('is-active')});
    }


} // end of class
